<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Tuan`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.76211 9.92262C9.27693 9.57244 8.59265 9.75418 8.34515 10.2989L5.61699 16.3038C5.33202 16.9311 5.79058 17.6431 6.47951 17.6431H17.2226C17.9745 17.6431 18.4268 16.8092 18.0166 16.1789L15.7891 12.7564C15.5398 12.3733 15.0526 12.2229 14.6307 12.3986L12.9182 13.1122L9.76211 9.92262ZM7.3621 16.1273L9.438 11.5581L12.2889 14.5274C12.5559 14.7201 12.9038 14.7603 13.2077 14.6337L14.7768 13.9799L16.1744 16.1273H7.3621Z"/><path d="M16.3782 8.532C16.3782 9.09354 15.923 9.54876 15.3615 9.54876C14.7999 9.54876 14.3447 9.09354 14.3447 8.532C14.3447 7.97046 14.7999 7.51524 15.3615 7.51524C15.923 7.51524 16.3782 7.97046 16.3782 8.532Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.85956 6.2718C1.85956 4.70215 3.13202 3.42969 4.70167 3.42969H19.2986C20.8682 3.42969 22.1407 4.70215 22.1407 6.2718V17.7285C22.1407 19.2982 20.8682 20.5706 19.2986 20.5706H4.70167C3.13202 20.5706 1.85956 19.2982 1.85956 17.7285V6.2718ZM3.52462 6.98604C3.52462 5.9396 4.37293 5.09129 5.41937 5.09129H18.5809C19.6273 5.09129 20.4756 5.9396 20.4756 6.98604V17.0133C20.4756 18.0598 19.6273 18.9081 18.5809 18.9081H5.41937C4.37293 18.9081 3.52462 18.0598 3.52462 17.0133V6.98604Z"/></svg>
</template>
<script>

export default {
  name: 'IconTuan',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
